<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-overlay :show="isLoading" rounded="sm">
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-navbar-brand href="#">
                <strong style="color:#3b3e66">Complaint Types</strong>
              </b-navbar-brand>

              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-button
                    @click="showAddComplaintTypeModal = !showAddComplaintTypeModal"
                    class="mr-2"
                    variant="outline-primary"
                    size="sm"
                  >
                    <font-awesome-icon icon="plus" />
                  </b-button>
                  <b-button variant="outline-info" size="sm" class="mr-2" @click="reloadTable">
                    <font-awesome-icon icon="sync" />
                  </b-button>
                  <b-form-group>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-nav-form>
              </b-navbar-nav>
            </b-navbar>
            <b-table
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              bordered
              ref="table"
              id="my-table"
              :fields="staticFields"
              :items="getComplaintTypesData"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              no-sort-reset
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(is_active)="data">
                <b-badge
                  :variant="data.item.is_active == 1 ? 'success' : 'danger'"
                >{{ data.item.is_active == 1 ? 'Active' : 'In Active'}}</b-badge>
              </template>
              <template v-slot:cell(actions)="data">
                <b-btn
                  @click="editComplaintType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-info"
                >
                  <font-awesome-icon icon="edit" />
                </b-btn>
                <b-btn
                  v-if="data.item.is_active == 1"
                  @click="deleteComplaintType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-danger"
                >Deactivate</b-btn>
                <b-btn
                  v-if="data.item.is_active == 0"
                  @click="activeComplaintType(data)"
                  class="mr-2"
                  size="sm"
                  variant="outline-success"
                >Activate</b-btn>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Showing Result From
                    <b>{{fromRows}}</b> to
                    <b>{{toRows}}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>

    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      :title="isEditComplaintType ? 'Update Complaint Type' : 'Add Complaint Type'"
      size="md"
      scrollable
      v-model="showAddComplaintTypeModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-form-group>
            <label class="text-left">
              Title:
              <span class="required-span">*</span>
            </label>
            <b-form-input
              v-model="$v.form.title.$model"
              :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
              size="sm"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{ isEditComplaintType ? 'Your Complaint Type is being Updateing......' : 'Your Complaint Type is being Creating......' }}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ isEditComplaintType ? 'Your Complaint Type has been updated successfully.' : 'Your Complaint Type has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetModal" variant="outline-danger">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{ isEditComplaintType ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteComplaintType" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deactivating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteComplaintTypeCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <b-overlay :show="showActiveComplaintType" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Activating...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetActiveModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="activeComplaintTypeCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "ComplaintTypes",
  mixins: [validationMixin],
  data() {
    return {
      showActiveComplaintType: false,
      isEditComplaintType: false,
      showDeleteComplaintType: false,
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      showAddComplaintTypeModal: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      toRows: 0,
      fromRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "type", label: "Title", sortable: true },
        { key: "is_active", label: "Is Active", sortable: true },
        { key: "actions", label: "Action", sortable: false },
      ],
      form: {
        title: null,
      },
      complaintTypeId: null,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  validations: {
    form: {
      title: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {},
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getComplaintTypesData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoading = true;
      let result = HTTP("post", "api/v1/complaints/type/get", formData);

      return result
        .then((response) => {
          const items = response.data.data;
          this.isLoading = false;
          this.fromRows = response.data.from;
          this.toRows = response.data.to;
          this.totalRows = response.data.total;
          return items;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    resetForm() {
      this.form = {
        title: null,
      };
      this.$v.$reset();
    },
    resetModal() {
      this.resetForm();
      this.complaintTypeId = null;
      this.isEditComplaintType = false;
      this.showAddComplaintTypeModal = false;
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.isEditComplaintType) {
        this.updateComplaintType().then(this.reloadTable);
      } else {
        this.saveComplaintType().then(this.reloadTable);
      }
    },
    async saveComplaintType() {
      let formData = {
        type: this.form.title,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP("post", "api/v1/complaints/type/create", formData);
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async updateComplaintType() {
      let formData = {
        complaint_type_id: this.complaintTypeId,
        type: this.form.title,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP(
          "put",
          "api/v1/complaints/type/" + this.complaintTypeId,
          formData
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    editComplaintType(data) {
      this.isEditComplaintType = true;
      this.complaintTypeId = data.item.id;
      this.form = {
        title: data.item.type,
      };
      this.showAddComplaintTypeModal = true;
    },
    deleteComplaintType(data) {
      this.complaintTypeId = data.item.id;
      this.processing = false;
      this.showDeleteComplaintType = true;
    },
    deleteComplaintTypeCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteComplaintTypeApiCall().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showDeleteComplaintType = this.processing = false;
          });
        }
      }, 200);
    },
    async deleteComplaintTypeApiCall() {
      let formData = {
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP(
          "post",
          "api/v1/complaints/type/delete/" + this.complaintTypeId,
          formData
        );
        this.complaintTypeId = null;
      } catch (err) {
        this.complaintTypeId = null;
        return [err];
      }
    },
    resetDeleteModal() {
      this.complaintTypeId = null;
      this.showDeleteComplaintType = false;
    },
    activeComplaintType(data) {
      this.complaintTypeId = data.item.id;
      this.showActiveComplaintType = true;
    },
    activeComplaintTypeCall() {
      this.counter = 1;
      this.processing = true;
      this.activeComplaintTypeApiCall().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showActiveComplaintType = this.processing = false;
          });
        }
      }, 200);
    },
    async activeComplaintTypeApiCall() {
      let formData = {
        is_active: 1,
        user_id: localStorage.getItem("userId"),
      };
      try {
        await HTTP(
          "put",
          "api/v1/complaints/type/" + this.complaintTypeId,
          formData
        );
        this.complaintTypeId = null;
      } catch (err) {
        this.complaintTypeId = null;
        return [err];
      }
    },
    resetActiveModal() {
      this.complaintTypeId = null;
      this.showActiveComplaintType = false;
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 0px;
}
</style>